import React from 'react';
import './experience.css';

export default function Experience() {
  const experiences = [
    {
      period: '2025 - Present',
      role: 'Founding AI Engineer',
      company: 'CraftIQ & SaaS Platforms',
      description: 'Architecting and scaling AI SaaS platforms designed to streamline media generation and automated compliance workflows.',
      achievements: [
        'Designed asynchronous FastAPI endpoints managing asset pipeline queues, handling concurrent processing demands.',
        'Developed content streaming architectures using Server-Sent Events (SSE), improving page speed parameters by 60%.',
        'Built CheckMate, a compliance SaaS validating regulatory documents with high accuracy using schema parsing gates.'
      ],
      tags: ['FastAPI', 'React', 'PostgreSQL', 'SSE', 'Supabase', 'Docker']
    },
    {
      period: '2024 - 2025',
      role: 'AI Engineer & Researcher',
      company: 'Biomarker Research & Medical Diagnostics Lab',
      description: 'Developed advanced AI-driven classification models and validation agents in the biotech and health domains.',
      achievements: [
        'Designed a Multi-Agentic RAG pipeline using LangGraph to validation medical biomarkers, dropping reference hallucinations to under 8%.',
        'Deployed vector indices using FAISS to index PubMed publications, enabling research citation matching under 15ms.',
        'Created a computer vision model for diabetic foot ulcer classification and early predictions using deep neural networks.'
      ],
      tags: ['LangGraph', 'Python', 'FAISS', 'PyTorch', 'Computer Vision', 'Django']
    },
    {
      period: '2023 - 2024',
      role: 'Full Stack & LLM Developer',
      company: 'Pathwise & Independent Work',
      description: 'Shipped end-to-end full stack web products and LLM conversational workflows for custom projects.',
      achievements: [
        'Built Pathwise AI, a career counselor chatbot routing chat context, embedding LangChain memory storage in Django.',
        'Configured CI/CD automation pipelines via GitHub Actions to run test validations automatically on push events.',
        'Implemented PostgreSQL schema optimizations to manage user data, chat histories, and platform analytics.'
      ],
      tags: ['Django', 'React', 'LangChain', 'Docker', 'GitHub Actions', 'PostgreSQL']
    }
  ];

  return (
    <div className="experience-container">
      <div className="experience-header">
        <span className="section-tag">Career Journey</span>
        <h2 className="section-title">Ownership & Impact</h2>
        <p className="section-subtitle">
          Translating research and server architectures into high-velocity production code.
        </p>
      </div>

      <div className="timeline">
        <div className="timeline-line"></div>
        {experiences.map((exp, index) => (
          <div className="timeline-item" key={index}>
            <div className="timeline-meta">
              <span className="timeline-period">{exp.period}</span>
              <span className="timeline-company">{exp.company}</span>
            </div>
            
            <div className="timeline-dot"></div>
            
            <div className="timeline-content premium-card">
              <h3 className="timeline-role">{exp.role}</h3>
              <p className="timeline-desc">{exp.description}</p>
              
              <ul className="timeline-achievements">
                {exp.achievements.map((ach, i) => (
                  <li key={i}>{ach}</li>
                ))}
              </ul>

              <div className="timeline-tags">
                {exp.tags.map((tag, i) => (
                  <span className="tech-badge" key={i}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
